import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "antd";
import PersonalInfo from "./components/personalInfo";
import UserImg from "./components/userImg";
import CardHeader from "../../components/atoms/cardHeader";
import CardWrapper from "../../components/molecules/CardWrapper";
import { useDispatch, useSelector } from "react-redux";
import { getVendorById } from "../../store/thunks/myProfileThunk";

// Profile Component
export default function MyProfile() {
  const { user } = useSelector((state) => state?.auth || {});
  const [profilePic, setProfilePic] = useState();

  const dispatch = useDispatch();
  const id = user?.id || data?.id;

  const { data } = useSelector((state) => state?.vendorById || {});
  useEffect(() => {
    if (id) dispatch(getVendorById({ id }));
  }, [id, dispatch]);


  return (
    <>
      <div className="mt-10">
        <CardWrapper>
          <CardHeader name="My Profile" tooltipText={"Manage your personal information, profile details, languages, and password settings."}/>
          <div className="card-body p-4">
            <Form>
              <Row gutter={[48, 12]}>
                <Col xs={24} lg={6}>
                  <UserImg
                    data={data}
                    id={id}
                    user={user}
                    profilePic={profilePic}
                    setProfilePic={setProfilePic}
                  />
                </Col>

                <Col xs={24} lg={18}>
                  <PersonalInfo
                    id={id}
                    user={data}
                   
                    profilePic={profilePic}
                    setProfilePic={setProfilePic}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </CardWrapper>
      </div>
    </>
  );
}
